import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Navbar from "@/components/Navbar";
import ProtectedRoute from "@/components/ProtectedRoute";

import AppLayout from "@/layouts/AppLayout";

import Home from "@/pages/Home";
import AuthPage from "@/pages/AuthPage";
import OAuthHandler from "@/pages/OAuthHandler";
import UserSDK from "@/pages/UserSDK";

import Payments from "@/pages/Payments";
import Dashboard from "@/pages/Dashboard";

import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentFailure from "@/pages/PaymentFailure";

import ProjectsLayout from "@/pages/projects/ProjectsLayout";
import CreateProjectWizard from "@/pages/projects/CreateProjectWizard";
import ProjectDashboard from "@/pages/projects/ProjectDashboard";
import ProjectTestPaymentPage from "@/pages/projects/ProjectTestPaymentPage";

function App() {
  return (
    <Router>
      <div className="bg-gray-50 dark:bg-gray-950 min-h-screen">

        {/* Navbar stays for now */}
        <Navbar />

        <Routes>

          {/* ───────────────── PUBLIC ROUTES ───────────────── */}
          <Route path="/" element={<Home />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/login" element={<Navigate to="/auth" replace />} />
          <Route path="/register" element={<Navigate to="/auth" replace />} />
          <Route path="/sdk" element={<UserSDK />} />

          {/* OAuth */}
          <Route path="/oauth" element={<OAuthHandler />} />

          {/* Payment Redirect Pages */}
          <Route path="/payments/success" element={<PaymentSuccess />} />
          <Route path="/payments/failure" element={<PaymentFailure />} />

          {/* ───────────────── PROTECTED AREA ───────────────── */}
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            {/* Dashboard */}
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Payments */}
            <Route path="/payments" element={<Payments />} />

            {/* Projects list */}
            <Route path="/projects" element={<ProjectsLayout />} />

            {/* Create project (NO sidebar inside ProjectsLayout) */}
            <Route path="/projects/create" element={<CreateProjectWizard />} />

            {/* Project dashboard */}
            <Route
              path="/projects/:id"
              element={
                <ProjectsLayout>
                  <ProjectDashboard />
                </ProjectsLayout>
              }
            />

            {/* Test payment */}
            <Route
              path="/projects/:id/test-payment"
              element={
                <ProjectsLayout>
                  <ProjectTestPaymentPage />
                </ProjectsLayout>
              }
            />
          </Route>

        </Routes>
      </div>
    </Router>
  );
}

export default App;
